export default [
  {
    path: '/clinical-billing',
    component: () => import(/* webpackChunkName: "billing-main" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
    },
  },
];
